import { render } from "./documentsTab.vue?vue&type=template&id=53dfff90&scoped=true"
import script from "./documentsTab.vue?vue&type=script&lang=ts"
export * from "./documentsTab.vue?vue&type=script&lang=ts"

import "./documentsTab.vue?vue&type=style&index=0&id=53dfff90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53dfff90"

export default script